import Entity from '@/entities/entity'

/*!
 * Doreceipt实体
 */
export default class Doreceipt extends Entity<number> {
  doId?: number

  tenantId?: number

  client?: string

  type?: string

  doNo?: string

  doBatch?: string

  quantity?: number

  referenceNo?: string

  doCategory?: string

  shipFromCode?: string

  shipFromName?: string

  shipFromCity?: string

  shipFromPostcode?: number

  shipFromState?: string

  shipFromCountry?: string

  shipToCode?: string

  shipToName?: string

  shipToCity?: string

  shipToPostcode?: number

  shipToState?: string

  shipToCountry?: string

  proposedSchedule?: string

  estimateArrival?: string

  routeSequence?: number

  vehicleNo?: string

  driver?: string

  truckSealNo?: string

  creationTime?: string
  creatorUserId?: number

  lastModificationTime?: string

  lastModifierUserId?: number

  needByDate?: string

  expectedDeliveryDate?: string

  status?: string

  recStatus?: string

  grStatus?: string

  grPostingDate?: string

  detailCount?: number
  recCount?: number

  receivedBy?: string

  driverName?: string

  completionTime?: string

  startTime?: string

  shipFromAddress1?: string

  shipFromAddress2?: string

  shipFromAddress3?: string

  shipFromAddress4?: string

  shipToAddress1?: string

  shipToAddress2?: string

  shipToAddress3?: string

  shipToAddress4?: string

  appearance?: number

  cleanliness?: number

  pest?: number

  driverProfessionalism?: number

  driverProfessionalismRate?: string

  closeSeal?: string

  attribute1?: string

  attribute2?: string

  attribute3?: string

  attribute4?: string

  attribute5?: string

  poNo?: string

  docNo?: string
}
